import { useCallback } from 'react'
import type { PanInfo } from 'motion/react'

const OFFSET_THRESHOLD = 80
const VELOCITY_THRESHOLD = 400

/**
 * Returns motion drag props for swipe-right-to-go-back gesture (mobile).
 * Attach the returned props to a `motion.div`.
 */
export function useSwipeBack(onBack: () => void) {
  const handleDragEnd = useCallback((_: unknown, info: PanInfo) => {
    if (info.offset.x > OFFSET_THRESHOLD || info.velocity.x > VELOCITY_THRESHOLD) {
      onBack()
    }
  }, [onBack])

  return {
    drag: 'x' as const,
    dragConstraints: { left: 0, right: 0 },
    dragElastic: { left: 0, right: 0.4 },
    dragSnapToOrigin: true,
    onDragEnd: handleDragEnd,
  }
}
